import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Loader2, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");
  const token = searchParams.get("token");

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setStatus("error");
        setMessage("Token de verificacao nao fornecido.");
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/api/auth/verify-email/${token}`);
        setStatus("success");
        setMessage(response.data.message);
      } catch (error) {
        setStatus("error");
        setMessage(error.response?.data?.detail || "Erro ao verificar e-mail. O token pode estar expirado.");
      }
    };

    verifyToken();
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4">
            {status === "loading" && (
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
              </div>
            )}
            {status === "success" && (
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                <CheckCircle className="w-8 h-8 text-green-600" />
              </div>
            )}
            {status === "error" && (
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                <XCircle className="w-8 h-8 text-red-600" />
              </div>
            )}
          </div>
          <CardTitle className="text-xl">
            {status === "loading" && "Verificando..."}
            {status === "success" && "E-mail Verificado!"}
            {status === "error" && "Erro na Verificacao"}
          </CardTitle>
          <CardDescription className="text-base mt-2">
            {message}
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          {status === "success" && (
            <Button 
              onClick={() => navigate("/login")} 
              className="w-full bg-blue-600 hover:bg-blue-700"
            >
              Ir para Login
            </Button>
          )}
          {status === "error" && (
            <div className="space-y-2">
              <Button 
                onClick={() => navigate("/login")} 
                variant="outline"
                className="w-full"
              >
                Voltar ao Login
              </Button>
              <p className="text-sm text-slate-500">
                Precisa de um novo link? Faca login e solicite o reenvio.
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
